import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "page visitor-list-page"
};
const _hoisted_2 = {
  key: 0,
  class: "con"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "text"
};
const _hoisted_5 = {
  class: "name"
};
const _hoisted_6 = {
  class: "label"
};
const _hoisted_7 = {
  class: "label"
};
const _hoisted_8 = {
  class: "footer"
};
import { onActivated, onDeactivated, onMounted, onUnmounted, ref } from "vue";
import { closeToast, showLoadingToast, showToast } from "vant";
import { useRouter } from "vue-router";
import { getDictData, getVisitorList } from "@/api/mini";
import { selectDictLabel, setTagType } from "@/utils";
import { encryptParam } from "@/utils/crypto";
import { onPageRefresh } from "@/utils/eventBus";
import { isWxWorkEnv, shareToChat } from "@/utils/wecomSdk";
import defaultPhoto from "@/assets/images/default_photo.png";
export default /*@__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {
    const router = useRouter();
    const search = ref("");
    const list = ref([]);
    const refreshing = ref(false);
    // visitor_status 字典：0 正常 1 待审核 2 审核不通过
    const dictList = ref([]);
    const tagType = status => setTagType(dictList.value, String(status !== null && status !== void 0 ? status : ""));
    const dictLabel = status => selectDictLabel(dictList.value, String(status !== null && status !== void 0 ? status : ""));
    let searchTimer = null;
    const onSearch = () => {
      if (searchTimer) clearTimeout(searchTimer);
      searchTimer = setTimeout(() => void loadList(), 300);
    };
    const loadDicts = async () => {
      const res = await getDictData("visitor_status");
      dictList.value = (res === null || res === void 0 ? void 0 : res.data) || [];
    };
    // silent：返回列表/下拉刷新时不弹 loading（下拉本身有动画、返回要无感），
    // 避免 keep-alive 页面每次回来都出现“重新加载”的闪屏
    const loadList = async (silent = false) => {
      if (!silent) showLoadingToast({
        message: "加载中...",
        forbidClick: true
      });
      try {
        const res = await getVisitorList({
          name: search.value
        });
        list.value = (res === null || res === void 0 ? void 0 : res.data) || [];
      } finally {
        if (!silent) closeToast();
      }
    };
    const onRefresh = async () => {
      try {
        await loadList(true);
      } finally {
        refreshing.value = false;
      }
    };
    const goDetail = id => {
      if (!id) return;
      router.push({
        path: "/door/visitor/detail",
        query: {
          id: String(id)
        }
      });
    };
    // 新增访客：带出当前登录人作为被访人（对齐小程序 addVisitor）
    const addVisitor = () => {
      var _user$companyId, _user$deptId;
      const user = getUser();
      router.push({
        path: "/door/visitor/add",
        query: {
          type: "1",
          cid: user.cid,
          companyId: String((_user$companyId = user.companyId) !== null && _user$companyId !== void 0 ? _user$companyId : ""),
          deptId: String((_user$deptId = user.deptId) !== null && _user$deptId !== void 0 ? _user$deptId : ""),
          interviewerName: user.name,
          interviewerId: user.personId
        }
      });
    };
    // 构建邀请链接：被访人信息加密后随链接带给访客登记页（type=0 被邀请填写，无需登录态），
    // 避免 cid/姓名/人员 id 明文暴露在链接中
    const buildInviteLink = () => {
      var _user$companyId2, _user$deptId2;
      const user = getUser();
      const {
        origin,
        pathname
      } = window.location;
      const token = encryptParam({
        type: "0",
        cid: user.cid,
        companyId: String((_user$companyId2 = user.companyId) !== null && _user$companyId2 !== void 0 ? _user$companyId2 : ""),
        deptId: String((_user$deptId2 = user.deptId) !== null && _user$deptId2 !== void 0 ? _user$deptId2 : ""),
        interviewerName: decodeURIComponent(user.name),
        interviewerId: user.personId
      });
      return `${origin}${pathname}#/door/visitor/add?t=${token}`;
    };
    const copyLink = link => {
      copyText(link).then(() => showToast("邀请链接已复制，可发送给访客填写")).catch(() => showToast("复制失败，请重试"));
    };
    // 邀请访客：企业微信内调起「自定义转发到会话」发送邀请卡片；
    // 非企业微信环境或调起失败时退回复制邀请链接
    const inviteVisitor = () => {
      const link = buildInviteLink();
      console.log('isWxWorkEnv', !isWxWorkEnv());
      if (!isWxWorkEnv()) {
        copyLink(link);
        return;
      }
      showLoadingToast({
        message: "正在调起转发...",
        forbidClick: true
      });
      console.log('正在调起转发');
      shareToChat({
        title: `${decodeURIComponent(getUser().name)} 邀请你登记来访信息`,
        desc: "点击填写访客登记，提交后凭人脸通行",
        link,
        // 卡片图标须为可公网访问的绝对地址；默认取应用内置头像图
        imgUrl: new URL(defaultPhoto, window.location.origin).href
      }).then(result => {
        closeToast();
        // cancel 为用户取消转发，无需提示
        if (result === "success") showToast("邀请已发送");
      }).catch(() => {
        closeToast();
        showToast("调起转发失败");
        copyLink(link);
      });
    };
    const getUser = () => {
      try {
        var _user$personId;
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        return {
          // 与小程序保持一致：companyId * 99 + 1 得到访客侧企业 id
          cid: String(Number(user.companyId || 0) * 99 + 1),
          companyId: user.companyId,
          deptId: user.deptId,
          name: encodeURIComponent(user.name || ""),
          personId: String((_user$personId = user.personId) !== null && _user$personId !== void 0 ? _user$personId : "")
        };
      } catch {
        return {
          cid: "",
          companyId: "",
          deptId: "",
          name: "",
          personId: ""
        };
      }
    };
    const copyText = text => {
      var _navigator$clipboard;
      if ((_navigator$clipboard = navigator.clipboard) !== null && _navigator$clipboard !== void 0 && _navigator$clipboard.writeText) {
        return navigator.clipboard.writeText(text);
      }
      return new Promise((resolve, reject) => {
        const input = document.createElement("textarea");
        input.value = text;
        input.style.position = "fixed";
        input.style.opacity = "0";
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy") ? resolve() : reject(new Error("copy fail"));
        } catch (error) {
          reject(error);
        } finally {
          document.body.removeChild(input);
        }
      });
    };
    // 数据变更标记：仅当登记页新增 / 详情页审核后回到本页时才静默刷新；
    // 其余返回场景（左滑返回等）直接使用 keep-alive 缓存，避免每次返回都重新拉数据
    const shouldRefreshWhenActivated = ref(false);
    let stopPageRefresh;
    onMounted(() => {
      void loadDicts();
      void loadList();
      stopPageRefresh = onPageRefresh("visitor-list", () => {
        shouldRefreshWhenActivated.value = true;
      });
    });
    onUnmounted(() => {
      var _stopPageRefresh;
      (_stopPageRefresh = stopPageRefresh) === null || _stopPageRefresh === void 0 || _stopPageRefresh();
    });
    // keep-alive 会把聚焦态原样缓存：输入框聚焦中离开（如左滑返回、点击列表项跳转），
    // 恢复页面时搜索框仍带着焦点样式，iOS 还会残留键盘顶起的视口偏移，表现为错位。
    // 离开页面前统一失焦，保证返回时搜索框是干净的默认状态
    onDeactivated(() => {
      var _document$activeEleme, _document$activeEleme2;
      (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 || (_document$activeEleme2 = _document$activeEleme.blur) === null || _document$activeEleme2 === void 0 || _document$activeEleme2.call(_document$activeEleme);
    });
    onActivated(() => {
      if (shouldRefreshWhenActivated.value) {
        shouldRefreshWhenActivated.value = false;
        void loadList(true);
      }
    });
    return (_ctx, _cache) => {
      const _component_van_search = _resolveComponent("van-search");
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_tag = _resolveComponent("van-tag");
      const _component_van_empty = _resolveComponent("van-empty");
      const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("main", _hoisted_1, [_createVNode(_component_van_search, {
        modelValue: search.value,
        "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => search.value = $event), onSearch],
        placeholder: "请输入访客姓名进行搜索",
        shape: "round"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_pull_refresh, {
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => refreshing.value = $event),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [list.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.modulePersonId,
            class: "item",
            onClick: $event => goDetail(item.modulePersonId)
          }, [_createVNode(_component_van_image, {
            round: "",
            fit: "cover",
            width: 40,
            height: 40,
            src: item.photoPath || _unref(defaultPhoto)
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, "访客姓名：" + _toDisplayString(item.name), 1), _createVNode(_component_van_tag, {
            type: tagType(item.status),
            class: "status-tag"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(dictLabel(item.status)), 1)]),
            _: 2
          }, 1032, ["type"])]), _createElementVNode("div", _hoisted_6, " 访客单位：" + _toDisplayString(item.workUnit ? item.workUnit : "无"), 1), _createElementVNode("div", _hoisted_7, "预约时间：" + _toDisplayString(item.beginTime), 1)])], 8, _hoisted_3);
        }), 128))])) : (_openBlock(), _createBlock(_component_van_empty, {
          key: 1,
          description: "暂无访客信息"
        }))]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_van_button, {
        type: "success",
        onClick: addVisitor
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode(" 新增访客 ")])),
        _: 1
      }), _createVNode(_component_van_button, {
        type: "primary",
        onClick: inviteVisitor
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("邀请访客")])),
        _: 1
      })])]);
    };
  }
});